import type { WorkspaceMode } from '../domain/types'

interface WorkspaceToggleProps {
  mode: WorkspaceMode
  onChange: (mode: WorkspaceMode) => void
}

export function WorkspaceToggle({ mode, onChange }: WorkspaceToggleProps) {
  return (
    <div className="workspace-toggle" role="group" aria-label="Choose workspace">
      <button
        type="button"
        className={mode === 'user' ? 'is-active' : ''}
        aria-label="User workspace"
        aria-pressed={mode === 'user'}
        onClick={() => onChange('user')}
      >
        <span className="toggle-kicker">Live it</span>
        User
      </button>
      <button
        type="button"
        className={mode === 'coach' ? 'is-active' : ''}
        aria-label="Coach workspace"
        aria-pressed={mode === 'coach'}
        onClick={() => onChange('coach')}
      >
        <span className="toggle-kicker">Guide it</span>
        Coach
      </button>
    </div>
  )
}
